import { Navigate } from "react-router-dom";

// Authentication
import Login from "modules/authentication/components/Login";
import Logout from "modules/authentication/components/Logout";
import RoleMasterMain from "modules/user-management/user-master-role/components/RoleMasterMain";
import CountryMasterMain from "modules/directory/country-master/components/CountryMaster";
import StateMasterMain from "modules/directory/state-master/components/StateMaster";
import CityMasterMain from "modules/directory/city-master/components/CityMaster";
import CategoryMasterMain from "modules/product/category/components/CategoryMasterMain";
import CompanyMasterMain from "../modules/product/Company/components/CompanyMasterMain";
import MetalColorMasterMain from "modules/product/MetalColor/components/MetalColorMain";
import RedumptionMasterMain from "modules/discount/reward/reward-redumption/components/RedumptionMasterMain";
import DiamondMakingChangesMasterMain from "modules/making-charges/diamond-making-charges/components/DiamondMakingChargesMain";
import CollectionMasterMain from "modules/product/Collection/components/CollectionMasterMain";
import OldGoldPurchaseRateMasterMain from "pages/Components/OldGoldPurchaseRate/OldGoldPurchaseRateMain";
import GoldMakingChangesMasterMain from "modules/making-charges/gold-making-charges/components/GoldMakingChangesMain";
import ReturnDeductionMaster from "pages/Components/Deduction/ReturnDeduction/ReturnDeductionMaster";
import WalkInSourceMaster from "modules/master/walk-in-source/components/WalkInSourceMaster";
import ProductMaster from "pages/Components/Product/ProductMaster";
import DiamondProductInventory from "modules/inward/diamond-product-inventory/components/DiamondProductInventory";
import GoldProductInventory from "modules/inward/gold-product-inventory/components/GoldProductInventory";
import GoldInventorySNMCC from "modules/snmcc/gold-inventory-snmcc/components/GoldInventorySNMCC";
import DiamondProductInward from "modules/inward/diamond-product-inward/components/DiamondProductInward";
import GoldProductInward from "modules/inward/gold-product-inward/components/GoldProductInward";
import GoldProductInwardSNMCC from "modules/snmcc/gold-product-inward-snmcc/components/GoldProductInwardSNMCC";
import ReturnToMayaveProduct from "modules/return/return-to-mayave-inventory/components/ReturnToMayaveProduct";
import ReturnToMayaveProductRequest from "modules/return/return-to-mayave-request/components1/ReturnToMayaveRequestList";
import CustomerMasterDataList from "modules/customer/components/CustomerMasterDataList";
import KaratMasterDataList from "modules/master/karat-master/components/KaratMasterMain";
import MetalMasterDataList from "modules/master/metal-master/components/MetalMasterMain";
import SalesEntryList from "modules/transactions/sales-entry-data-list/components/SalesEntryList";
import GoldRateMasterMain from "modules/master/gold-rate/components/GoldRateMain";
import MaterialTypeMaster from "modules/master/material-type/components/MaterialTypeMaster";
import RewardEarningMasterMain from "modules/discount/reward/earning-reward/components/RewardMasterMain";
import StoreOperationRoleMain from "modules/store/StoreOperationRoles/components/StoreOperationRoleDataList";
import StoreMasterMain from "modules/store/StoreMaster/components/StoreMasterDataList";
import SalesPersonDataList from "modules/store/SalePerson/components/SalesPersonDataList";
import BillTypeMaster from "modules/store/BillType/components/BillTypeDataList";
import BillSettingMaster from "modules/store/BillSetting/components/BillSettingDataList";
import RejectReasonMaster from "modules/master/reject-reason/components/RejectReasonMaster";
import PaymentTypeMaster from "modules/master/payment-type/components/PaymentTypeMaster";
import RepairWorkMain from "modules/master/repair-work/components/RepairWorkMain";
import DiamondShapeMasterMain from "modules/product/DiamondShape/components/DiamondShapeMain";
import DiscountMasterMain from "modules/discount/consumer-offer/components/DiscountMasterMain";
import DiamondProductInwardSNMCC from "modules/snmcc/diamond-product-inward-snmcc/components/DiamondProductInwardSNMCC";
import DiamondInventorySNMCC from "modules/snmcc/diamond-inventory-snmcc/components/DiamondInventorySNMCC";
import DiscountVoucherMasterMain from "modules/discount/discount-voucher/components/DiscountVoucherMaster";
import Default from "modules/dashboard/components/default";
import EnquiryMasterMain from "modules/transactions/enquiry-master/components/EnquiryMasterMain";
import NewSalesEntry from "modules/transactions/new-sales-entry/components/SalesEntryMain";
import UserMasterDataList from "modules/user-management/user-master/components/UserMasterDataList";
import UserProfile from "modules/authentication/components/user-profile";
import BaggingDataList from "modules/transactions/bagging-list/component/BaggingDatalist";
import OldGoldDataList from "modules/transactions/old-gold-list/components/OldGoldDataList";
import OldGoldRequest from "modules/transactions/old-gold-request/component/OldGoldRequestData";
import CustomerLedger from "pages/Components/Transactions/CustomerLedger/CustomerLedger";
import SalesInventoryDataList from "../modules/sales-inventory/components/SalesInventoryData";
import ReturnTofranchise from 'modules/return-to- franchise/return-customer-to-franchise/customerTofranchiase/components/CustomerToFranchiaseList'
import RetunSalesList from 'modules/return-to- franchise/return-sales-list/ReturnSalesList'
import ReturnSalesDataList from "modules/return/ReturnSalesList/components/ReturnSalesDataList";
import ReturnToMayaveStoreRequestList from "modules/return/return-to-mayave-request/components1/ReturnToMayaveRequestList";
import LoginRedirectWrapper from "./authHook/LoginRedirectWrapper";
import EstimatePaymentReceipt from "modules/transactions/estimate-payment-receipt/estimate-payment-receipt/components/EstimatePaymentReceipt";
import CustomOrderList from "modules/transactions/customorder-list/components/CustomOrderList";
import RepairWorkSearch from "modules/repair-work/repair-work-search/components/RepairWorkSearch";
import RepairProductsDetails from "modules/repair-work/repair-work-search/components/RepairProductsDetails";
import RepairProductList from "modules/repair-work/repair-product-list/components/RepairProductList";
import RepairProductBagList from "modules/repair-work/repair-product-list/components/RepairProductBagList";
import RepairedBagList from "modules/repair-work/repair-product-list/components/RepairedBagList";
import RepairProductsDetails1 from "modules/repair-work/repair-work-search/components/RepairProductsDetails1";
import ReportPage from "modules/report/components/ReporCardtList";
import DailyReportList from "modules/report/pages/DailyReport/components.ts/DailyReportList";
import StockReportList from "modules/report/pages/stockReport/components/StrockReportList";
import CollectionReportDataList from "modules/report/pages/CollectionReport/components/CollectionReportDataList";
import RevenueReportDataList from "modules/report/pages/RevenueReport/components/RevenueReportDataList";
import InwartReportDataList from "modules/report/pages/InwardReport/components/InwartReportDataList";
import AdvanceReportDataList from "modules/report/pages/AdvanceReport/components/AdvanceReportDataList";
import OgReportDataList from "modules/report/pages/OgReport/component/OgReportDataList";
import GoldRateLogReportDataList from "../modules/report/pages/goldRateLogReport/components/GoldRateLogReportDataList";
import InterStorePaymentDetails from "modules/interStore-transfer/components/InterStorePaymentDetails";
import CustomerReferral from "modules/reward/referrale/CustomerReferral";
import RewardHistory from "modules/reward/reward-history/RewardHistoryMainList";
import BirthdayAndAniverssary from "modules/reward/birthdayandaniversery/BirthdayAndAniverssaryMainList";
import InterStoreRequestedInventory from "modules/interStore/interStore-RequestInventory/InterStoreRequestedInventoryMain";
import InterStoreTransferDataList from "modules/interStore/interStore-transfer/components/InterStoreTransferDataList";
import InterStoreProductAccess from "modules/interStore-transfer/components/InterStoreProductAccess";
import StoreLedger from "modules/Ledger/StoreLeadger";
import ReturnPolicySection from "modules/dashboard/ReturnPolicy/ReturnPolicySection";
import CartDataList from "modules/cart-list/CartDataList";
import RewartReportList from "modules/report/pages/RewardReport/components/RewartReportList";
import EcomDraftOrderList from "modules/ecom/components/EcomDraftOrderList";


const authProtectedRoutes = [
    // Dashboard
    { path: "/dashboard", component: <Default /> },
    { path: "/", element: <Navigate to="/dashboard" replace /> },
    { path: "*", component: <Navigate to="/dashboard" /> },
    // Module.1 - Dashboard #
    { path: "/dashboard", name: "Analytics Dashboard", component: <Default /> },

    {
        path: "/old-gold-purchase-rate",
        name: "Old Gold Purchase Rate",
        component: <OldGoldPurchaseRateMasterMain />,
    },
    { path: "/category", name: "Category", component: <CategoryMasterMain /> },
    {
        path: "/collection",
        name: "Collection",
        component: <CollectionMasterMain />,
    },
    { path: "/company", name: "Company", component: <CompanyMasterMain /> },

    // 6. Transactions
    {
        path: "/transaction-enquiry",
        name: "Transaction Enquiry",
        component: <EnquiryMasterMain />,
    },
    {
        path: "/old-gold-purchase-list",
        name: "Old Gold Purchase List",
        component: <OldGoldDataList />,
    },
    {
        path: "/old-gold-request",
        name: "Old Gold Request",
        component: <OldGoldRequest />,

    },
    {
        path: "/customer-ledger",
        name: "Customer Ledger",
        component: <CustomerLedger />,
    },
    // 10. Return Deduction
    {
        path: "/return-deduction",
        name: "Return Deduction",
        component: <ReturnDeductionMaster />,
    },
    {
        path: "/return-sales",
        name: "Return Sales",
        component: <ReturnSalesDataList />,
    },
    {
        path: "/return-sales",
        name: "Return Sales",
        component: <ReturnSalesDataList />,
    },
    // 11. Payment Type
    {
        path: "/payment-type",
        name: "Payment Type",
        component: <PaymentTypeMaster />,
    },
    //12. Repair Work
    { path: "/repair-work", name: "Repair Work", component: <RepairWorkMain /> },

    // Module.3 - Product Inward
    // 1. Inward :
    {
        path: "/diamond-product-inward",
        name: "Diamond Product Inward",
        component: <DiamondProductInward />,
    },
    {
        path: "/gold-product-inward",
        name: "Gold Product Inward",
        component: <GoldProductInward />,
    },
    // 2. inventory :
    {
        path: "/diamond-product-inventory",
        name: "Diamond Product Inventory",
        component: <DiamondProductInventory />,
    },
    {
        path: "/gold-product-inventory",
        name: "Gold Product inventory",
        component: <GoldProductInventory />,
    },

    // Module.4 - SNMCC product
    // 1. Inward :
    {
        path: "/SNMCC-diamond-product-inward",
        name: "SNMCC-Diamond Product Inward",
        component: <DiamondProductInwardSNMCC />,
    },
    {
        path: "/SNMCC-gold-product-inward",
        name: "SNMCC-Gold Product Inward",
        component: <GoldProductInwardSNMCC />,
    },
    // 2. inventory :
    {
        path: "/SNMCC-diamond-product-inventory",
        name: "SNMCC-Diamond Product Inventory",
        component: <DiamondInventorySNMCC />,
    },
    {
        path: "/SNMCC-gold-product-inventory",
        name: "SNMCC-Gold Product inventory",
        component: <GoldInventorySNMCC />,
    },

    // Module.5 - return  #
    {
        path: "/return-inventory",
        name: "Return Inventory",
        component: <ReturnToMayaveProduct />,
    },
    {
        path: "/return-request",
        name: "Return Request",
        component: <ReturnToMayaveStoreRequestList />,
    },
    //return to franchise
    {
        path: '/return-to-franchise',
        name: "Return Customer To Franchise ",
        component: <ReturnTofranchise />
    },
    {
        path: '/return-franchise-list',
        name: "Return Sales list",
        component: <RetunSalesList />
    },

    // Module.6 - Transaction
    {
        path: "/new-transaction-entry/:coid?/:cid?",
        name: "New Transaction Entry",
        component: <NewSalesEntry />,
    },
    {
        path: "/make-to-order",
        name: "Estimate Payment Receipt",
        component: <EstimatePaymentReceipt />,
    },
    {
        path: "/new-transaction-entry/:coid?/:cid?",
        name: "New Transaction Entry",
        component: <NewSalesEntry />,
    },
    {
        path: "/make-to-order",
        name: "Estimate Payment Receipt",
        component: <EstimatePaymentReceipt />,
    },

    {
        path: "/sales-entry-list",
        name: "Sales Entry List",
        component: <SalesEntryList />,
    },
    {
        path: "/cart-details",
        name: "Cart",
        component: <CartDataList />,
    },
    {
        path: "/bagging-list",
        name: "Bagging List",
        component: <BaggingDataList />,
    },
    {
        path: "/custom-order-list",
        name: "Custom Order List",
        component: <CustomOrderList />,
    },

    // Module 7 - profile
    {
        path: "/user-profile",
        name: "User Profile",
        component: <UserProfile />,
        permissionTitle: "UserRole",
    },

    // Sales Invetory
    {
        path: "/sales-inventory",
        name: "Sales Inventory",
        component: <SalesInventoryDataList />,
    },

    // Repair work
    {
        path: "/repair-product-search",
        name: "Repair Product Search",
        component: <RepairWorkSearch />,
    },
    {
        path: "/repair-products-details/:id/:customerId",
        name: "Repair Products Details",
        component: <RepairProductsDetails />,
    },
    {
        path: "/repair-product-details/:repairWorkItemId",
        name: "Repair Product - Work Item View",
        component: <RepairProductsDetails1 />,
    },

    {
        path: "/repair-product-list",
        name: "Repair Products List",
        component: <RepairProductList />,
    },
    {
        path: "/repair-product-bag-list",
        name: "Repair Products Bag List",
        component: <RepairProductBagList />,
    },
    {
        path: "/repaired-bag-list",
        name: "Repaired Bag List",
        component: <RepairedBagList />,
    },
    {
        path: "/report-page",
        name: "Report",
        component: <ReportPage />,
    },
    {
        path: "/stock-report",
        name: "Stock-report",
        component: <StockReportList />,
    },
    {
        path: "/daily-report",
        name: "Daily-report",
        component: <DailyReportList />,
    },
    {
        path: "/og-purchase-report",
        name: "Og-Purchase-report",
        component: <OgReportDataList />,
    },
    {
        path: "/collection-report",
        name: "Collection-report",
        component: <CollectionReportDataList />,
    },
    {
        path: "/daily-collection-report",
        name: "Daily-Collection-report",
        component: <RevenueReportDataList />,
    },
    {
        path: "/inward-report",
        name: "inward-report",
        component: <InwartReportDataList />,
    },
    {
        path: "/advance-report",
        name: "advance-report",
        component: <AdvanceReportDataList />,
    },
    {
        path: "/og-purchase-report",
        name: "old-gold-report",
        component: <OgReportDataList />,
    },
    // interStore Items
    {
        path: "/interStore-inventory",
        name: "InterStoreInventory",
        component: <InterStoreTransferDataList />,
    },
    {
        path: "/interStore-transfer",
        name: "InterStoreTransfer",
        component: <InterStoreProductAccess />,
    },
    {
        path: "/interStore-payment",
        name: "InterStorePaymentDetails",
        component: <InterStorePaymentDetails />,
    },
    {
        path: "/interStore-inventory",
        name: "InterStoreInventory",
        component: <InterStoreTransferDataList />,
    },
    {
        path: "/interStore-transfer",
        name: "InterStoreTransfer",
        component: <InterStoreProductAccess />,
    },
    {
        path: "/interStore-payment",
        name: "InterStorePaymentDetails",
        component: <InterStorePaymentDetails />,
    },
    {
        path: "/interStore-Request",
        name: "InterStoreRequestInventory",
        component: <InterStoreRequestedInventory />,
    },
    {
        path: "/Customer-Referral",
        name: "Referral",
        component: <CustomerReferral />
    },
    {
        path: "/reward-History",
        name: "Reward History",
        component: <RewardHistory />
    },
    {
        path: "/birthday-anniversary",
        name: "Birthday and Aniversary List",
        component: <BirthdayAndAniverssary />
    },
    {
        path: "/store-ledger",
        name: "store-ledger",
        component: <StoreLedger />
    },
    {
        path: "/return-policy",
        name: "return-policy",
        component: <ReturnPolicySection />

    },
    {
        path: "/reward-report",
        name: "reward-report",
        component: <RewartReportList />

    },
    {
        path: "/ecom-draft-orders",
        name: "ecom-draft-orders",
        component: <EcomDraftOrderList />

    },
    {
        path: "/user-master",
        name: "User Master",
        component: <UserMasterDataList />,
    },
    {
        path: "/role-master",
        name: "Role Master",
        component: <RoleMasterMain />,
    },
    {
        path: "/goldRate-log-report",
        name: "goldRate-log-report",
        component: <GoldRateLogReportDataList />,
    },
];

const publicRoutes = [
    { path: "/login", name: "Login", component: <LoginRedirectWrapper />, },
    { path: "/logout", name: "Logout", component: <Logout /> },
];

export { authProtectedRoutes, publicRoutes };